
import {JOURNEY_STEP} from '../reducers/global.js';

export default function updateJourney(value){
    return{
        type: JOURNEY_STEP,
        value
    }
}